import { types } from "../types/types";

const initialState = {
  isLoading: true,
  refunds: [],
  refundActivo: null,
};

export const refundReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.refundsLoading:
      return {
        ...state,
        isLoading: false,
        refunds: [...action.payload],
      };

    case types.refundSetLoading:
      return {
        ...state,
        isLoading: true,
      };

    case types.refundSetActive:
      return {
        ...state,
        refundActivo: action.payload,
      };

    case types.refundClearActive:
      return {
        ...state,
        refundActivo: null,
      };

    default:
      return state;
  }
};
